import { Vue } from 'vue-property-decorator';

import accountService from '@/services/account.service';

export default {

    unblock(context: Vue, userBlockedId: number): Promise<void> {
        let url: string = context.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "unblock";
        const form = {
          userBlockedId,
        };
        return accountService.post(context, url, form, { headers: { Authorization: "Bearer " + context.$store.getters.token.Value } })
    },
}